"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableRestorePointsInteractor = void 0;
const core_1 = require("@veeam/core");
require("./AvailableRestorePointsDataGridModel");
class AvailableRestorePointsInteractor extends core_1.Interactor {
    constructor(dataGridModel, listeners, presenters) {
        super();
        this.dataGridModel = dataGridModel;
        this.listeners = listeners;
        this.presenters = presenters;
        this.onRestore = () => {
            const id = this.getSelectedId();
            if (!id) {
                return;
            }
            this.listeners.onRestore(id);
        };
        this.onRemove = () => __awaiter(this, void 0, void 0, function* () {
            const id = this.getSelectedId();
            if (!id) {
                return;
            }
            this.presenters.loadingState(true);
            yield this.listeners.onRemove(id);
            this.presenters.loadingState(false);
            yield this.dataGridModel.load();
        });
        this.onExport = () => {
            const id = this.getSelectedId();
            if (!id) {
                return;
            }
            this.listeners.onExport(id);
        };
        this.onClose = () => {
            var _a, _b;
            this.listeners.onDeactivate();
            (_b = (_a = this.listeners).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.onCancel = () => {
            var _a, _b;
            this.listeners.onDeactivate();
            (_b = (_a = this.listeners).onCancel) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.dataGridModel = dataGridModel;
        this.listeners = listeners;
        this.presenters = presenters;
    }
    getSelectedId() {
        const [restorePoint] = this.dataGridModel.getSelectedItems();
        return restorePoint.id;
    }
}
exports.AvailableRestorePointsInteractor = AvailableRestorePointsInteractor;
//# sourceMappingURL=AvailableRestorePointsInteractor.js.map